import React, {Component} from 'react';
import API from "../../services/API";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDoubleLeft, faAngleLeft, faEye, faIdCard, faPhone, faTruck} from "@fortawesome/free-solid-svg-icons";
import Actionbar from "../Common/Actionbar";
import Loading from "../Common/Loading";
import BlacklistHistory from "./BlacklistHistory";

class DriverProfile extends Component {
    state  =  {
        isLoaded: false,
        driverStatus : []
    }
    render() {
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Actionbar noBack={0} title='پروفایل راننده'/>
                <section className="container p-4 rtl mt-4">
                    <div className='row mt-2 pb-3 border-bottom' key={this.state.id}

                    >
                        <div className="col-12 text-center">
                            <img src={this.state.avatar} alt="avatar" className='w-25 rounded-more'/>
                        </div>
                        <div className="col-12 text-center fw-bold  my-2">
                            {this.state.first_name}
                            &nbsp;
                            {this.state.last_name}

                            {
                                this.state.in_black_list > 0 &&
                                <div className='alert alert-danger super-small-2 p-0 text-center mt-2' style={{fontSize: '12px'}}>
                             کاربر در حال حاضر در لیست سیاه قرار دارد!
                                </div>
                            }
                            {
                                this.state.in_warning_list > 0 &&
                                <div className='alert alert-warning super-small-2 p-0 text-center mt-2' style={{fontSize: '12px'}}>
                                    کاربر در حال حاضر در لیست تذکر قرار دارد!
                                </div>
                            }
                        </div>
                    </div>
                    <div className="row mt-3 pb-3 border-bottom">
                        <div className="col-5 small">
                            <FontAwesomeIcon icon={faIdCard} className='text-success '/>
                            &nbsp;
                            کد ملی:
                        </div>
                        <div className="col-7 text-left ltr fw-bold">


                                &nbsp;     &nbsp;
                                {this.state.national_id }


                        </div>
                    </div>
                    <div className="row mt-3 pb-3 border-bottom">
                        <div className="col-5 small">
                            <FontAwesomeIcon icon={faPhone} className='text-secondary '/>
                            &nbsp;
                            شماره تماس:
                        </div>
                        <div className="col-7 text-left ltr">
                            <a href={'tel:'+ this.state.mobile} className='text-decoration-none text-dark' >
                                <FontAwesomeIcon icon={faAngleLeft} className='text-success '/>
                                &nbsp;     &nbsp;
                                {this.state.mobile && this.state.mobile.replace('+98' , '0')}

                            </a>
                        </div>
                    </div>
                    <div className="row mt-3 pb-3 border-bottom small">
                        <div className="col-5 ">
                            <FontAwesomeIcon icon={faTruck} className='text-secondary '/>
                            &nbsp;
                          نوع خودرو
                        </div>
                        <div className="col-7 text-left fw-bold ">
                            <span  className='text-decoration-none text-dark' >
{this.state.cars && this.state.cars.parent}
                                &nbsp;
                                -
                                &nbsp;
                                {this.state.cars && this.state.cars.type}

                            </span>
                        </div>
                        <div className="col-5 mt-4 ">
                            <FontAwesomeIcon icon={faIdCard} className='text-secondary '/>
                            &nbsp;
                          پلاک خودرو
                        </div>
                        <div className="col-7 text-left  mt-4 ">


                                {this.state.cars && this.state.cars.plaque}


                        </div>
                        <div className="col-5 mt-4 ">
                            <FontAwesomeIcon icon={faIdCard} className='text-secondary '/>
                            &nbsp;
                          ابعاد خودرو
                        </div>
                        <div className="col-7 text-left  mt-4 ">


                                {this.state.cars && this.state.cars?.dimensions?.width},
                                {this.state.cars && this.state.cars?.dimensions?.height},
                                {this.state.cars && this.state.cars?.dimensions?.length}


                        </div>
                    </div>
                    <div className="row alert alert-info mt-2">
                        <div className="col-5 small">
                            آخرین اعلام حضور:
                        </div>
                        <div className="col-7 text-left fw-bold">
                            {this.state.last_present ? this.state.last_present : 'بدون اعلام حضور'

                            }
                        </div>
                    </div>
                    <div className="row my-3">
                        <div className="col-12">
                            <button className='btn btn-outline-primary w-100 super-small'
                                    onClick={ () => {
                                        this.props.history.push(`/driver-requests/0/${this.props.match.params.id}`)
                                    }}
                            >
                                مشاهده همه درخواست های
                                &nbsp;
                                {this.state.first_name}
                                &nbsp;
                                {this.state.last_name}
                                <FontAwesomeIcon icon={faAngleDoubleLeft} className='float-left' />
                            </button>
                        </div>
                    </div>

                    <div className="row alert alert-success mt-2">
                        <div className="col-10 small">
                            آخرین بار حمل شده:
                            {this.state.last_transport_request ?
                                <span>
                                    در تاریخ
                                    &nbsp;
                                    {this.state.last_transport_request.date}
                                    &nbsp;
                                    برای شرکت
                                    &nbsp;
                                    <b>{this.state.last_transport_request.company}</b>
                                </span>

                                : ' '

                            }
                        </div>
                        <div className="col-2 text-left fw-bold"
                        onClick={() => {this.props.history.push('/request/' + this.state.last_transport_request.id)}}
                        >
                            {this.state.last_transport_request ?

                                <FontAwesomeIcon icon={faEye} className='text-secondary '/>
                                : ''}
                        </div>
                    </div>
                    <div className="row text-center">

                        <div className="col-12 bg-info">
                            تعداد درخواست راننده در هر مرحله

                        </div>
                        <div className="col-6 bg-secondary text-white super-small fw-bold ">مرحله درخواست</div>
                        <div className="col-4 bg-secondary text-white super-small fw-bold">تعداد</div>
                        <div className="col-2 bg-secondary text-white super-small fw-bold">مشاهده</div>
                    </div>
                        {
                            this.state.driverStatus.map(status => {
                                return (
                                    <div className="row text-center mt-1 small border-bottom p-2"
                                        onClick={ () => {
                                            this.props.history.push(`/driver-requests/${status.status_id}/${this.props.match.params.id}`)
                                        }}
                                    >
                                        <div className="col-6">
                                            {
                                                status.status
                                            }
                                        </div>
                                        <div className="col-4">
                                            {
                                                status.count
                                            }
                                        </div>
                                        <div className="col-2">
                                            <FontAwesomeIcon icon={faEye} className='text-info '/>
                                        </div>
                                    </div>
                                )
                            })
                        }

                </section>
                <BlacklistHistory history={this.state.black_list_history} />
            </React.Fragment>
        );
    }
    componentDidMount = () => {

        API.profile(this.props.match.params.id)
            .then((response) => {
                this.setState(response.results.user)
                this.setState({driverStatus : response.results.driverStatus})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
    }
}

export default DriverProfile;